import { render, staticRenderFns } from "./Portals.vue?vue&type=template&id=2ad73c97&"
import script from "./Portals.vue?vue&type=script&lang=js&"
export * from "./Portals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports